/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-garage': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M249.72 75.74l-98-29.4a5.93 5.93 0 00-3.44 0l-98 29.4A6 6 0 0046 81.49V238a6 6 0 006 6h16a6 6 0 006-6v-96h152v96a6 6 0 006 6h16a6 6 0 006-6V81.49a6 6 0 00-4.28-5.75zM54 83l96-28.8L246 83v13H54zm20 21h152v14H74zm-8 132H54V104h12zm8-98v-16h152v16zm172 98h-12V104h12z"/><path pid="1" d="M200.68 200.87l-7.53-3.77-6.93-17.33a6 6 0 00-5.57-3.77h-61.3a6 6 0 00-5.57 3.77l-6.93 17.33-7.53 3.77a6 6 0 00-3.32 5.37V226a8 8 0 008 8h6v5a5 5 0 0010 0v-5h60v5a5 5 0 0010 0v-5h6a8 8 0 008-8v-19.76a6 6 0 00-3.32-5.37zm-80-16.87h58.58l4.8 12h-68.15zM104 226v-18.53l6.94-3.47h78.12l6.94 3.47V226z"/><circle pid="2" cx="115" cy="215" r="5"/><circle pid="3" cx="185" cy="215" r="5"/><path pid="4" d="M130 208h40v4h-40zM130 218h40v4h-40z"/>'
  }
})
